import { auth, useAuthState } from '../../../api/services/firebase';

const useUserData = () => {
  const [user] = useAuthState(auth);
  const [firstName, lastName] = user ? user.displayName.split(' ') : ['', ''];
  const email = user?.email;
  return { firstName, lastName, email };
};

export default useUserData;
